module.exports = __webpack_public_path__ + "media/icons/lightbox_user-9f54d72c.svg";